import React, { useEffect } from 'react';
import { Card, Typography, Spin } from 'antd';
import Format from '../../../../../lib/Format';

const { Title, Text } = Typography;

const prettify = (raw = '') =>
  raw
    .replace(/^_?\d+_?/, '')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();

const keepSubKey = (k) =>
  !k.endsWith('_Rating') &&
  !/^Choice\d+$/i.test(k) &&
  !/^Question\d+$/i.test(k);

const renderAnswer = (value) => {
  if (Array.isArray(value))
    return value.map((item, idx) => <div key={idx}>{item}</div>);

  if (typeof value === 'object') {
    return Object.entries(value)
      .filter(([k]) => keepSubKey(k))
      .map(([k, v]) => (
        <div key={k}>
          {prettify(k)}: {Array.isArray(v) ? v.join(', ') : String(v)}
        </div>
      ));
  }

  return <div>{String(value)}</div>;
};

const OnboardingScreen = ({
  cognitoFormAnswer,
  load,
  partnershipId,
  careGuideId,
}) => {
  useEffect(() => {
    load(partnershipId, careGuideId);
  }, [load, partnershipId, careGuideId]);

  if (!cognitoFormAnswer)
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <Spin />
      </div>
    );

  const qaPairs = cognitoFormAnswer.answers.filter(([, v]) => {
    if (v === null || v === undefined || v === '') return false;
    if (Array.isArray(v)) return v.length > 0;
    if (typeof v === 'object') return Object.keys(v).some((k) => keepSubKey(k));
    return true;
  });

  return (
    <Card
      title={
        <Title level={5}>
          {Format.dateTable(cognitoFormAnswer.created_at)}
        </Title>
      }
      style={{ marginTop: 20 }}
      bodyStyle={{ padding: '24px 32px' }}
    >
      {qaPairs.map(([q, a]) => (
        <div key={q} style={{ marginBottom: 16 }}>
          <Text strong style={{ fontSize: 16 }}>
            {prettify(q)}
          </Text>
          {renderAnswer(a)}
        </div>
      ))}
    </Card>
  );
};

export default OnboardingScreen;
